import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#274290',
        secondary: '#a71c20',
        accent: '#274290',
        error: '#a71c20',
      }
    }
  }
});
